import { DataWizardAct, TextActVM } from 'civil-status/view-models/step-form';

export const transformTextAnnotationOld = (data: DataWizardAct): TextActVM => {
  return {
    text: data.evento?.composizioneCompletaAnnotazione || '',
  };
};
